import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Typography, Spin, QRCode } from 'antd';
import TransactionService from '../../services/transaction_service';
import { Page, PaymentStatus } from '../../common/constant';
import { useTranslation } from "react-i18next";
import { colorError } from '../../shared/theme';

/// <summary>
/// Author: Wei Xiang
/// </summary>
const Duitnow = () => {
    const _transactionService = new TransactionService();
    const [loading, setLoading] = useState(true);
    const [qrDetail, setQrDetail] = useState(null);
    const [timeLeft, setTimeLeft] = useState(null);
    const [qrValidUntil, setQrValidUntil] = useState(null);
    const _navigate = useNavigate();
    const _location = useLocation();
    const { amount, paymentMethod } = _location.state || {};
    const { t } = useTranslation();

    /// <summary>
    /// Author: Wei Xiang
    /// </summary>
    useEffect(() => {
        let intervalId;
        const initPayment = async () => {
            try {
                setLoading(true);

                const response = await _transactionService.initPayment({
                    amount,
                    methodId: paymentMethod?.methodId,
                });

                const responseDataJson = JSON.parse(response.data)
                setQrDetail(responseDataJson);
                setQrValidUntil(responseDataJson.qrValidUntil)

                const checkPaymentStatus = async () => {
                    try {
                        const { userId, transactionId, vendorTransactionId } = responseDataJson
                        const statusResponse = await _transactionService.checkPaymentStatus({ userId, transactionId, vendorTransactionId });

                        if (statusResponse.data.status === PaymentStatus._SUCCESS || statusResponse.data.status === PaymentStatus._FAILED) {
                            clearInterval(intervalId);
                            _navigate(Page._PAYMENT_RESULT, {
                                replace: true,
                                state: { response: statusResponse }
                            });
                        }
                    } catch (error) {
                        handlePaymentStatus();
                    }
                };

                intervalId = setInterval(checkPaymentStatus, 3500);
            } catch (error) {
                handlePaymentStatus();
            } finally {
                setLoading(false);
            }
        };

        initPayment();
        return () => clearInterval(intervalId);
    }, []);

    /// <summary>
    /// Author: Wei Xiang
    /// </summary>
    useEffect(() => {
        let interval
        if (qrValidUntil !== null) {
            interval = setInterval(() => {
                const remainingTime = calculateTimeLeft(qrValidUntil);
                setTimeLeft(remainingTime);

                if (qrValidUntil !== null && remainingTime <= 0) {
                    clearInterval(interval);
                    const response = {
                        title: t("PAYMENT_FAILED"),
                        message: t("QR_CODE_TIMEOUT"),
                        icon: {
                            name: 'times-circle',
                            color: colorError,
                        },
                    };
                    _navigate(Page._PAYMENT_RESULT, { state: { response }, replace: true });
                }
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [qrValidUntil]);

    /// <summary>
    /// Author: Wei Xiang
    /// </summary>
    function calculateTimeLeft(expiry) {
        const now = new Date();
        const expiryTime = new Date(expiry);
        const diff = expiryTime - now;
        return diff > 0 ? diff : 0;
    }

    /// <summary>
    /// Author: Wei Xiang
    /// </summary>
    function formatTime(milliseconds) {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }

    /// <summary>
    /// Author: Wei Xiang
    /// </summary>
    const handlePaymentStatus = () => {
        const response = {
            title: t("PAYMENT_FAILED"),
            message: t("CONTACT_ADMIN_FOR_HELP"),
            icon: {
                name: 'times-circle',
                color: colorError,
            },
        };
        _navigate(Page._PAYMENT_RESULT, { state: { response }, replace: true });
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#f0f2f5'
        }}>
            {loading || timeLeft === null ? (
                <Spin size="large" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }} />
            ) :
                <div style={{
                    width: '320px',
                    padding: '20px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <img src='duitnow.png' width={"100px"} />
                    <Typography.Text style={{ textAlign: "center", marginTop: 12 }}>Kindly scan the QR code below to proceed with payment</Typography.Text>
                    <Typography.Text style={{ textAlign: "center" }}>Please do not refresh the page</Typography.Text>
                    <Typography.Text style={{ textAlign: "center", marginTop: 4, marginBottom: 12, fontWeight: "bold" }}>Expires in {formatTime(timeLeft)}</Typography.Text>
                    <div style={{ background: "#ed2a67", padding: 12, textAlign: "center", borderRadius: "8px" }}>
                        <Typography.Title level={4} style={{ margin: 0, marginBottom: 12, color: 'white' }}>RM {amount.toFixed(2)}</Typography.Title>
                        <QRCode value={qrDetail?.qrPayload} size={240} status={qrDetail?.qrPayload ? "active" : "loading"} color={"#ed2a67"} bgColor={"white"} style={{ marginBottom: 8 }} />
                        <Typography.Text style={{ color: 'white', fontWeight: "bold" }}>MALAYSIA NATIONAL QR</Typography.Text>
                    </div>
                </div >}
        </div >
    );
};

export default Duitnow;